// ── Avatar preview view ───────────────────────────────────────────────────────
// Shows the selected avatar large (reusing the upload-preview layout) with the
// Try On / Add Combo actions. Reached from the avatar selection view.

import { MUTED } from '../tokens';
import { esc } from '../helpers';
import { comboChooserHTML, comboCtaLabel, resolveTryonType, tryOnSubmitLabel, wireComboChooser } from '../combo-chooser';
import type { ViewContext } from '../modal-types';

export function renderAvatarPreview(ctx: ViewContext): void {
  const { state, content, set, handleAvatarSubmit } = ctx;
  const avatar = state.avatars.find((a) => a.id === state.selectedAvatarId) ?? null;
  const canCombo = !!resolveTryonType(ctx.opts, state);

  content.innerHTML = `
    ${ctx.headerHTML()}
    <div class="ts-mbody ts-flow-layout">
      <div class="ts-flow-panel">
        ${state.error ? `<div class="ts-error">${esc(state.error)}</div>` : ''}
        ${avatar ? `
        <div class="ts-up-preview">
          <div class="ts-dz ts-dz-preview ts-avatar-preview">
            <img src="${esc(avatar.signedUrl)}" alt="Avatar preview" />
          </div>
          <div class="ts-btn-row">
            <button class="ts-btn-primary" id="ts-tryon-avatar" type="button">${tryOnSubmitLabel(ctx.opts, state)}</button>
            <button class="ts-combo-cta" id="ts-combo-cta" type="button" ${canCombo ? '' : 'disabled'}>${comboCtaLabel(state)}</button>
          </div>
          ${comboChooserHTML(state)}
          <button class="ts-btn-ghost" id="ts-change-avatar" type="button" style="margin-top:8px">← Change avatar</button>
        </div>
        ` : `
          <div style="text-align:center;padding:32px 0 16px;color:${MUTED};font-size:14px">No avatar selected.</div>
          <button class="ts-btn-ghost" id="ts-change-avatar" type="button">← Back to avatars</button>
        `}
      </div>
    </div>
  `;

  content.querySelector('#ts-tryon-avatar')?.addEventListener('click', () => {
    if (state.selectedAvatarId) void handleAvatarSubmit(state.selectedAvatarId);
  });

  // Fade the avatar image in once loaded (natural ratio fills the card) and
  // reflow the modal so it hugs the avatar image like the upload preview / scan.
  const previewImg = content.querySelector<HTMLImageElement>('.ts-avatar-preview img');
  if (previewImg) {
    if (previewImg.complete && previewImg.naturalWidth > 0) {
      previewImg.classList.add('ts-img-loaded');
      ctx.reflow();
    } else {
      previewImg.addEventListener('load', () => {
        previewImg.classList.add('ts-img-loaded');
        ctx.reflow();
      });
    }
  }

  content.querySelector('#ts-combo-cta')?.addEventListener('click', () => {
    void ctx.onComboCta();
  });
  wireComboChooser(ctx);

  content.querySelector('#ts-change-avatar')?.addEventListener('click', () => {
    set({ phase: 'avatars', error: null });
  });
}
